import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import CustomTable from "../CustomTable";
import AccordionViaTableRowName from "../AccordionViaTableRowName";

const PackageItems = ({ 
  items = [], 
  packageActiveData, 
  userActiveData, 
  collection, 
  shipmentCollection,
  addItemButton
}) => {
  // const [activeDataName, setActiveDataName] = useState(null);
  // const [activeDataImage, setActiveDataImage] = useState("");

  const headCells = [
    { id: "no", label: "No" },
    { id: "name", label: "Item Name" },
    {
      id: "qty",
      label: "Qty",
      align: "right",
    },
    {
      id: "addons",
      label: "Add-ons",
      align: "right",
    },
    {
      id: "customsIQ",
      label: "CustomsIQ",
      align: "right",
    },
    {
      id: "documents",
      label: "Documents",
      align: "right",
    },
  ];

  const createData = (
    no,
    item_img,
    itemId,
    name,
    fullName,
    subCategory,
    category,
    qty,
    addons,
    customsIQ,
    receipt_img,
    acceptedAddons,
    path
  ) => {
    return {
      no,
      item_img,
      itemId,
      name,
      fullName,
      subCategory,
      category,
      qty,
      addons,
      customsIQ,
      receipt_img,
      acceptedAddons,
      path,
    };
  };

  const rows = items.map((item, index) =>
    createData(
      index + 1,
      item?.itemImageURL || item?.itemImage || "",
      item?.id || "",
      item?.shortenedName || item?.itemName || item?.name || "",
      item?.name || item?.fullName || "",
      item?.subcategory || item?.subCategory || "",
      item?.category || "",
      item?.quantity || 1,
      item?.addonsList || item?.addons || [],
      item?.customiqRestrictions || item?.customsIQ || [],
      item?.receiptImageURL || item?.receiptImage || "",
      item?.acceptedAddons || [],
      item?.path || ""
    )
  );

  // const handleBackButton = () => {
  //   setActiveDataName(null);
  // };

  // const packageClickHandler = () => {
  //   setActiveDataName(null);
  // };

  if (!items || items.length === 0) {
    return (
      <Box sx={{ paddingBottom: "30px" }}>
        <Box sx={{ 
          marginLeft: "20px", 
          marginTop: "20px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
          <Typography
            variant="h4"
            sx={{
              textAlign: "left",
              fontSize: "26px",
              fontWeight: "bold",
            }}
          >
            Item List
          </Typography>
          {addItemButton}
        </Box>
        <Box sx={{ marginLeft: "20px", marginTop: "20px" }}>
          <Typography variant="body1" color="text.secondary">
            No items found for this package.
          </Typography>
        </Box>
      </Box>
    );
  }

  // if (activeDataName) {
  //   return (
  //     <AccordionViaTableRowName
  //       handleBack={handleBackButton}
  //       packageClickHandler={packageClickHandler}
  //       id={activeDataName}
  //       packageActiveData={packageActiveData}
  //       userActiveData={userActiveData}
  //       packageItems={items}
  //       pageName="shippingRequest"
  //       packageCollection={collection}
  //       shipmentCollection={shipmentCollection}
  //     />
  //   );
  // }

  return (
    <Box sx={{ paddingBottom: "30px" }}>
      <Box sx={{ 
        marginLeft: "20px", 
        marginTop: "20px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <Typography
          variant="h4"
          sx={{
            textAlign: "left",
            fontSize: "26px",
            fontWeight: "bold",
          }}
        >
          Item List
        </Typography>
        {addItemButton}
      </Box>
      
      <CustomTable
        rows={rows}
        headCells={headCells}
        // setActiveDataName={setActiveDataName}
        // setActiveDataImage={setActiveDataImage}
        packageActiveData={packageActiveData}
        userActiveData={userActiveData}
        packageCollection={collection}
        shipmentCollection={shipmentCollection}
      />
    </Box>
  );
};

export default PackageItems; 